module.exports = __webpack_public_path__ + "img/image-home-step01.c592d046.png";